import { VStack } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { Divider, Show } from 'shared';

import {
  CoachSessionsDate,
  CoachSessionsTime,
} from 'features/sessions/components/Form/SessionInfo';
import { NextSessionInfoGoToSessionButton } from 'features/sessions/components/NextSessionInfo/GoToSessionButton';
import { CoachSessionScheduleNextSessionButton } from 'features/sessions/components/ScheduleNextSessionButton';

export const CoachSessionNextSessionInfo = () => {
  const { getValues } = useFormContext();
  const { email: emailFromParams } = useParams();

  const [
    clientEmail,
    coachingSessionId,
    nextSessionStartDate,
    nextSessionEndAt,
    nextSessionAttendance,
    nextSessionClientEmail,
  ] = getValues([
    'clientEmail',
    'coachingSessionId',
    'nextSessionAppointment.startAt',
    'nextSessionAppointment.endAt',
    'nextSessionAppointment.attendance',
    'nextSessionAppointment.clientEmail',
  ]);

  return (
    <Show
      when={!nextSessionStartDate}
      fallback={
        <>
          <CoachSessionsDate
            sessionDate={nextSessionStartDate}
            attendance={nextSessionAttendance}
            data-testid="left-sidebar-session-date"
          />
          <CoachSessionsTime
            startTime={nextSessionStartDate}
            endTime={nextSessionEndAt}
          />
          <NextSessionInfoGoToSessionButton
            email={clientEmail || nextSessionClientEmail || emailFromParams}
          />
        </>
      }
    >
      <VStack gap={4} w="full">
        <CoachSessionScheduleNextSessionButton
          currentSessionId={coachingSessionId}
          dataTestid="schedule-next-session-sidebar"
        >
          Schedule next session
        </CoachSessionScheduleNextSessionButton>
        <Divider />
      </VStack>
    </Show>
  );
};
